import FilterLevel1 from './FilterLevel1';
import FilterLevel2and3 from './FilterLevel2and3';
import SearchBar from './SearchBar';

const Filter = (props) => {
  const {
    categoryList,
    activeL1,
    activeL2,
    activeL3,
    handleFilterChange,
    handleSearchValue,
  } = props;

  return (
    <section className='filter'>
      <div className='searchbar-container'>
        <SearchBar handleSearchValue={handleSearchValue} />
      </div>

      <div className='menu-Level1'>
        {categoryList && (
          <ul
            className={`filterLevel${categoryList[0].filterLevel} border-red`}
          >
            {categoryList[0].categories.map((category, index) => {
              return (
                <FilterLevel1
                  category={category}
                  handleFilterChange={(e) => {
                    handleFilterChange(e);
                  }}
                  key={index}
                  activeL1={activeL1}
                />
              );
            })}
          </ul>
        )}
      </div>
      <div className='menu-Level2'>
        {categoryList && (
          <ul
            className={`filterLevel${categoryList[1].filterLevel} border-grey`}
          >
            {categoryList[1].categories.map((category, index) => {
              return (
                <FilterLevel2and3
                  category={category}
                  key={index}
                  activeL2={activeL2}
                  activeL3={activeL3}
                  handleFilterChange={(e) => {
                    handleFilterChange(e);
                  }}
                />
              );
            })}
          </ul>
        )}
        {categoryList && (
          <ul
            className={`filterLevel${categoryList[2].filterLevel} border-green`}
          >
            {categoryList[2].categories.map((category, index) => {
              return (
                <FilterLevel2and3
                  category={category}
                  key={index}
                  activeL3={activeL3}
                  handleFilterChange={(e) => {
                    handleFilterChange(e);
                  }}
                />
              );
            })}
          </ul>
        )}
      </div>
    </section>
  );
};

export default Filter;
